import React from 'react';
import { COUNTRIES } from '../utils/phone';

// 国家/地区区号选择器（中国+86 默认 / 日本+81 / 新加坡+65）
// 无边框贴合各页现有输入框样式，由外层容器提供边框
export default function CountryCodeSelect({ value, onChange, style }) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      style={{
        border: 'none', outline: 'none', cursor: 'pointer',
        background: '#F0EBE3', color: '#6B5E4E',
        fontFamily: 'var(--mono)', fontSize: 13,
        padding: '0 6px', flexShrink: 0,
        appearance: 'auto',
        ...style,
      }}
    >
      {COUNTRIES.map(c => (
        <option key={c.cc} value={c.cc}>{c.flag} {c.cc}</option>
      ))}
    </select>
  );
}
